<template>
  <div class="ec-line002">
    <div class="flex flex-col lg:flex-row lg:flex-wrap lg:text-lg lg:bg-white">
      <div class="ec-line002__img">
        <!-- <img :src="data.img" :alt="data.name" /> -->
        <the-carrousel :data="slides" />
      </div>
      <div class="ec-line002__block">
        <h1 class="ec-line002__title">{{ data.name }}</h1>
        <div class="ec-line002__description">
          <h2>{{ $t('ec-line002.content.description') }}</h2>
          <text-ellipsis class="with-more-btn" :rows="4" :inline="isShowMore" :action="showShowMoreButton">
            <span class="text-base lg:text-lg leading-normal align-top whitespace-pre-wrap">{{
              data.product_caption
            }}</span>
          </text-ellipsis>
          <span :class="['ec-line002__description__more-btn', { 'lg:inline': isShowButton }]" @click="onShowMore">
            {{ $t('ec-line002.content.showMore') }}
          </span>
        </div>
        <div class="ec-line002__category">{{ data.category }}</div>
        <div class="ec-line002__price">
          <slot name="price" v-bind:skuSelected="skuItemSelected"> </slot>
          <el-tag class="text-sm leading-normal h-auto">{{ $t('ec-line017.content.subscriptionProduct') }}</el-tag>
        </div>
        <div class="ec-line002__stock mt-2 text-red-150" v-if="!sku1List.length && !sku2List.length">
          {{ $t('ec-line017.content.notSkuVisible') }}
        </div>
        <div class="ec-line002__stock mt-2" v-else-if="!skuItemSelected.stock_unlimited">
          <span v-if="skuItemSelected.stock >= 6" class="text-black">{{ $t('ec-line017.content.inStock') }}</span>
          <span v-else-if="skuItemSelected.stock > 0" class="text-red-150">{{
            $t('ec-line017.content.remaining', { stock: skuItemSelected.stock })
          }}</span>
          <span v-else class="text-red-150">{{ $t('ec-line017.content.outOfStock') }}</span>
        </div>
        <template v-if="!isProductOnly && sku1List.length && sku2List.length">
          <sku-list
            class="ec-line002__sku mt-5"
            :label="skuName1"
            :items="sku1List"
            :selected.sync="skuSelected[0]"
          ></sku-list>
          <sku-list
            class="ec-line002__sku mt-3"
            :label="skuName2"
            :items="sku2List"
            :selected.sync="skuSelected[1]"
          ></sku-list>
        </template>

        <div class="w-full mt-4 text-center">
          <el-button
            class="submit-btn"
            :disabled="(!isProductOnly && !skuItemSelected) || outOfStock || (!sku1List.length && !sku2List.length)"
            @click="submit"
            >{{ labelButton }}</el-button
          >
        </div>
      </div>
      <div class="ec-line002__caption">
        <h2 class="px-4">{{ $t('ec-line002.content.description') }}</h2>
        <div class="text-base lg:text-lg leading-normal align-top whitespace-pre-wrap px-4">
          {{ data.product_caption }}
        </div>
      </div>
    </div>
    <div class="ec-line002__body" v-html="data.description_detail"></div>
  </div>
</template>

<script>
import { ENV_KEY } from '@/constants/env'
import SkuList from '../SkuList.vue'
import TheCarrousel from '../TheCarrousel.vue'
import TextEllipsis from '@/components/TextEllipsis.vue'

export default {
  components: { TheCarrousel, SkuList, TextEllipsis },
  props: {
    data: { type: Object, default: () => {} },
    items: { type: Array, default: () => [] },
    labelSubmit: { type: String, default: () => '' },
    labelRoute: { type: String, default: () => '' },
  },
  data() {
    return {
      skuSelected: [null, null],
      saleTypeSelected: null,
      isShowMore: false,
      isShowButton: false,
    }
  },
  computed: {
    slides() {
      return this.data?.product_images?.map((i) =>
        Object.assign({ img: `${this.$store.getters['env/GET_KEY'](ENV_KEY.IMAGE_API)}/${i.file_name}` })
      )
    },
    isProductOnly() {
      return (
        this.data.product_sku?.length === 1 &&
        !this.data.product_sku[0].sku_set_item1_id &&
        !this.data.product_sku[0].sku_set_item1_id
      )
    },
    skuName1() {
      return this.data.product_sku && this.data.product_sku[0].sku_item_parent_name_1
    },
    skuName2() {
      return this.data.product_sku && this.data.product_sku[0].sku_item_parent_name_2
    },
    sku1List() {
      const filterList =
        (this.skuSelected[1] &&
          this.data.product_sku.filter((i) => i.sku_set_item2_id === this.skuSelected[1] && i.visible)) ||
        this.data.product_sku
      return this.$_.uniqBy(filterList, 'sku_set_item1_id').map((i) =>
        Object.assign({ id: i.sku_set_item1_id, name: i.sku_set_item_name1 })
      )
    },
    sku2List() {
      const filterList =
        (this.skuSelected[0] &&
          this.data.product_sku.filter((i) => i.sku_set_item1_id === this.skuSelected[0] && i.visible)) ||
        this.data.product_sku
      return this.$_.uniqBy(filterList, 'sku_set_item2_id').map((i) =>
        Object.assign({ id: i.sku_set_item2_id, name: i.sku_set_item_name2 })
      )
    },
    skuItemSelected() {
      return this.data.product_sku?.find(
        (i) => i.sku_set_item1_id === this.skuSelected[0] && i.sku_set_item2_id === this.skuSelected[1]
      )
    },
    labelButton() {
      return this.items.some((i) => i.product_sku_id === this.skuItemSelected?.id) ? this.labelRoute : this.labelSubmit
    },
    outOfStock() {
      return (this.skuItemSelected && !this.skuItemSelected.stock_unlimited && !this.skuItemSelected.stock) || false
    },
  },
  watch: {
    data(val) {
      this.onSelectSku1(val.product_sku[0].sku_set_item1_id)
      this.onSelectSku2(val.product_sku[0].sku_set_item2_id)
    },
  },
  mounted() {
    window.setTimeout(() => {
      if (this.$refs.textEllipsis?.$el.offsetHeight < this.$refs.textEllipsis?.$el.scrollHeight) {
        this.isShowButton = true
      } else {
        this.isShowButton = false
      }
    }, 500)
  },
  methods: {
    submit() {
      this.$emit('submit', {
        ...this.skuItemSelected,
      })
    },
    onSelectSku1(id) {
      this.skuSelected[0] = id
    },
    onSelectSku2(id) {
      this.skuSelected[1] = id
    },
    onShowMore() {
      this.isShowMore = true
      this.isShowButton = false
    },
    showShowMoreButton(el) {
      if (el.$el.offsetHeight < el.$el.scrollHeight) {
        this.isShowButton = true
      } else {
        this.isShowButton = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/css/pages/ec-line002.scss';
</style>
